import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdumoeftPaymentResponse } from 'src/app/interfaces/adumoeft/Adumoeft';
import { Session } from 'src/app/interfaces/session-data';
import { AdumoeftService } from 'src/app/services/adumoeft/adumoeft.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-eft-version-two',
  templateUrl: './eft.component.html',
  styleUrls: ['./eft.component.scss']
})
export class EftComponent implements OnInit {
  loading = true;
  config = { leftTime: 5, format: 's' };
  sessionData: Session;

  constructor(
    private adumoeftService: AdumoeftService,
    private router: Router,
    private sessionService: SessionService
  ) {
    sessionStorage.setItem('selected-payment', 'eft_adumo');
  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.adumoeftService.initializePayment(sessionStorage.getItem('sessionToken')).subscribe((data: AdumoeftPaymentResponse) => {
      console.log(data);
      //window.location.href=data.paymentUrl;
    }, (err: HttpErrorResponse) => {
      this.navigateToStatus();
    });
  }

  navigateToStatus() {
    this.loading = false;
    this.router.navigate(
      [`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
  }
}
